import { IconButton, Stack, Typography, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC, ReactNode } from "react";

type Props = {
	icon: LucideIcon;
	onIconClick: () => void;
	title: string;
	startAdornment?: ReactNode;
	endAdornment?: ReactNode;
};

export const ChatTopBar: FC<Props> = ({
	icon: Icon,
	onIconClick,
	title,
	startAdornment,
	endAdornment,
}) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={theme.spacingTokens.sm}
			flexShrink={0}
			px={theme.spacingTokens.sm}
			py={theme.spacingTokens.sm}
			bgcolor={theme.palette.background.paper}
		>
			<IconButton
				variant="ghost"
				onClick={onIconClick}
				sx={{
					position: "relative",
					"&::before": {
						content: '""',
						position: "absolute",
						inset: "-6px",
					},
				}}
			>
				<Icon size={theme.iconSize.lg} color={theme.palette.grey[600]} />
			</IconButton>

			{startAdornment}

			<Typography variant="bodyStrong" noWrap flex={1} minWidth={0}>
				{title}
			</Typography>

			{endAdornment}
		</Stack>
	);
};
